export const SET_PROGRESS = 'SET_PROGRESS';
export const SET_CONFIG = 'SET_CONFIG';